<template>
  <Layout>
    <div id="contact_footer">
      <div id="contract_footer_first_col">
        <h4 style="color: #ffffff">快速入口</h4>
        <br/>
        <p>客户案例</p>
        <p>自研产品</p>
        <p>产品快报</p>
        <p>报价</p>
      </div>
      <div id="contract_footer_second_col">
        <h4 style="color: #ffffff">支持与服务</h4>
        <br/>
        <p>自助工具</p>
        <p>咨询与设计</p>
      </div>
      <div id="contract_footer_third_col">
        <h4 style="color: #ffffff">新闻动态</h4>
        <br/>
        <p>周一例会</p>
        <p>公司培训</p>
        <p>参与活动</p>
      </div>
      <div style="position:absolute;left:1100px;top:35px;width: 1px;height: 135px; background: #fff;"></div>
      <div id="contract_footer_forth_col">
        <h3 style="color: #ffffff;">联系电话：</h3>
        <h3 style="color: #ffffff;font-size: 20px">025-8715 7078</h3>
        <h3 style="color: #ffffff;">联系邮箱：</h3>
        <h3 style="color: #ffffff;font-size: 20px">webace_i3c@163.com</h3>
      </div>
      <div id="contact_inner_footer">
        <p>法律声明&nbsp;|&nbsp;隐私政策声明&nbsp;|&nbsp;可接受的使用政策&nbsp;|&nbsp;用户协议&nbsp;|&nbsp;举报不良信息&nbsp;|&nbsp;<a style="color: white" href="http://beian.miit.gov.cn">苏ICP备18008676号</a></p>
        <div style="position:absolute;width: 100%;height: 1px; background: #000;"></div>
        <p>2019 &copy; 江苏万维艾斯网络智能产业创新中心有限公司</p>
      </div>
    </div>
    <BackTop :height="100" :bottom="200">
      <div class="top">返回顶端</div>
    </BackTop>
  </Layout>
</template>

<script>
export default {
  name: 'i-footer'
}
</script>

<style scoped>
  .top{
    padding: 10px;
    background: rgba(0, 153, 229, 0.7);
    color: #fff;
    text-align: center;
    border-radius: 2px;
  }
  #contact_footer{
    position:absolute;
    left:0;
    width: 100%;
    background-color: #050a38;
    color: #ffffff;
    font-size: 14px;
    height: 230px;
    text-align: left;
  }
  #contract_footer_first_col{
    position:absolute;
    top: 35px;
    left:578px;
    height: 150px;
    width: 100px;
  }

  #contract_footer_second_col{
    position:absolute;
    top: 35px;
    left:750px;
    height: 150px;
    width: 100px;
  }

  #contract_footer_third_col{
    position:absolute;
    top: 35px;
    left:940px;
    height: 150px;
    width: 100px;
  }

  #contract_footer_forth_col{
    position:absolute;
    top: 35px;
    left:1160px;
    height: 150px;
    width: 150px;
  }
  #contact_inner_footer{
    text-align: center;
    margin-top: 185px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/Footer.vue